export default __webpack_public_path__ + "static/media/googleads.0f4264d7.svg";